var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.1 97.4",
    style: {
      enableBackground: "new 0 0 84.1 97.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#13499F;stroke-width:6.2897;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.8,47.5C72.4,38,64.6,31.9,53.2,31.9c-7.3,0-11.4,7-11.4,7s-4.1-7-11.4-7c-11.4,0-19.3,6.1-21.7,15.5 C4.4,64.3,22,90,30.3,90c8.8,0,7.7-6.4,11.4-6.4c3.7,0,2.6,6.4,11.4,6.4C61.5,90,79.1,64.3,74.8,47.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 41.8,
    y1: 38.9,
    x2: 41.8,
    y2: 10.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,20c0,0-29.6,4.5-29.6-5.3S41.8,15.6,41.8,20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthProfile);
export default __webpack_public_path__ + "static/media/health_profile.4b870bc8d3c836bb40c8404d82abe5c7.svg";
export { ForwardRef as ReactComponent };